import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';

/**
 * ConvertBrite API client for making requests to the ConvertBrite API
 */
class ConvertBriteClient {
  private client: AxiosInstance;
  
  constructor() {
    const baseURL = process.env.REACT_APP_CP_CONVERTBRITE_BASE_URL;
    
    this.client = axios.create({
      baseURL,
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': process.env.REACT_APP_CP_CONVERTBRITE_AUTH_TOKEN
      }
    });
  }
  
  /**
   * Make a GET request to the ConvertBrite API
   * @param url The endpoint URL
   * @param config Optional Axios request configuration
   * @returns Promise with the response data
   */
  async get<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
    const response = await this.client.get<T>(url, config);
    return response.data;
  }
  
  /**
   * Make a POST request to the ConvertBrite API
   * @param url The endpoint URL
   * @param data The request payload
   * @param config Optional Axios request configuration
   * @returns Promise with the response data
   */
  async post<T>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
    const response = await this.client.post<T>(url, data, config);
    return response.data;
  }
  
  /**
   * Make a PUT request to the ConvertBrite API
   * @param url The endpoint URL
   * @param data The request payload
   * @param config Optional Axios request configuration
   * @returns Promise with the response data
   */
  async put<T>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
    const response = await this.client.put<T>(url, data, config);
    return response.data;
  }
  
  /**
   * Make a DELETE request to the ConvertBrite API
   * @param url The endpoint URL
   * @param config Optional Axios request configuration
   * @returns Promise with the response data
   */
  async delete<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
    const response = await this.client.delete<T>(url, config);
    return response.data;
  }
}

// Export a singleton instance
export const convertBriteClient = new ConvertBriteClient();